import React, { Fragment, useState } from 'react';

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Title from '../components/title'
import ActiveUsers from '../components/active-users'
import YouTube from '../components/you-tube'
import Testimonal from '../components/testimonal'
import './home.css'

const Home = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const testimonals = [
    {
      id: 1,
      from: "Variant",
      name: "Efrain Galvis",
      quote:
        'Ingeniero DevOps, Cloud y de automatización con 9 años de experiencia en el manejo y administración de insfraestructura Cloud, optimización de costos y automatización de flujos',
      avatarSrc: "/image502912-6wy-200h.png",
    },
    {
      id: 2,
      from: "Variant",
      name: "Hermann Galvis",
      quote:
        "Ingeniero DevOps, Cloud y de automatización con 6 años de experiencia manejo y administración de insfraestructura Cloud y automatización de flujos",
      avatarSrc: "/image502912-6wy-200h.png",
    }
    
  ];

  const [iTestimonial, setITestimonial] = useState(0);
  const visibleTestimonials = 3;

  const next = () => {
    if (iTestimonial + visibleTestimonials < testimonals.length) {
      setITestimonial(iTestimonial + 1);
    }
  };

  const last = () => {
    if (iTestimonial > 0) {
      setITestimonial(iTestimonial - 1);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText("hgalvis@variant.com.co");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="home-container10">
      <Helmet>
        <title>Variant AI</title>
        <meta property="og:title" content="Variant AI" />
        <link
          rel="canonical"
          href="https://active-online-software-page-y2y752.teleporthq.app/"
        />
      </Helmet>
      <section className="home-thq-hero-elm">
        <header className="home-thq-header-elm1">
          <div id="mobile-menu" className="home-thq-mobile-navigation-elm">
            <img
              alt="pastedImage"
              src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              className="home-thq-logo-elm1"
            />
            <div className="home-thq-links-elm1">
              <span className="Link">Solutions</span>
              <span className="Link">How it works</span>
              <span className="Link">Prices</span>
            </div>
            <div
              id="close-mobile-menu"
              className="home-thq-close-mobile-menu-elm"
            >
              <svg viewBox="0 0 804.5714285714286 1024" className="home-icon10">
                <path d="M741.714 755.429c0 14.286-5.714 28.571-16 38.857l-77.714 77.714c-10.286 10.286-24.571 16-38.857 16s-28.571-5.714-38.857-16l-168-168-168 168c-10.286 10.286-24.571 16-38.857 16s-28.571-5.714-38.857-16l-77.714-77.714c-10.286-10.286-16-24.571-16-38.857s5.714-28.571 16-38.857l168-168-168-168c-10.286-10.286-16-24.571-16-38.857s5.714-28.571 16-38.857l77.714-77.714c10.286-10.286 24.571-16 38.857-16s28.571 5.714 38.857 16l168 168 168-168c10.286-10.286 24.571-16 38.857-16s28.571 5.714 38.857 16l77.714 77.714c10.286 10.286 16 24.571 16 38.857s-5.714 28.571-16 38.857l-168 168 168 168c10.286 10.286 16 24.571 16 38.857z"></path>
              </svg>
            </div>
          </div>
          <div className="home-thq-desktop-navigation-elm">
            <nav className="home-thq-centered-elm">
              <div className="home-thq-left-elm1">
                <img
                  alt="pastedImage"
                  src="/logo%20temporal-200h.png"
                  className="home-thq-logo-elm2"
                />
                <span className="home-text103">VARIANT</span>
                <div className="home-thq-links-elm2">
                  <span className="home-text104 Link">Inicio</span>
                  <a href="#how-works" className="home-text105 Link">
                    ¿Cómo funciona?
                  </a>
                  <a href="#suscriptions" className="home-text106 Link">
                    Suscríbete
                  </a>
                  <a href="/politica-de-privacidad" className="home-text105 Link">Política de Privacidad</a>
                </div>
              </div>
              <div className="home-thq-right-elm1">
                <span className="home-thq-sign-in-elm Link"> <a href="#nosotros" className="home-text105 Link">
                    Nosotros
                  </a></span>
                <div
                  className="home-thq-get-started-elm1"
                  onClick={() => setShowModal(true)}
                >
                  <button className="home-text107">Contacto</button>
                </div>
                {showModal && (
                  <div
                    className="modal-overlay"
                    onClick={(e) => {
                      if (e.target === e.currentTarget) {
                        setShowModal(false);
                      }
                    }}
                  >
                    <div className="modal-content">
                      <div className="modal-contact-info">
                        <h1>Contactate con nosotros</h1>

                        <div className="modal-contact-buttons">
                          <a
                            className="whatsApp-button"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://api.whatsapp.com/send?phone=573209683760"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.75"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon-2"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
                              <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
                            </svg>
                            Chatea con nuestro Bot
                          </a>
                          <button className="email-button" onClick={handleCopy}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.75"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon-2"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10" />
                              <path d="M3 7l9 6l9 -6" />
                            </svg>
                            {copied
                              ? "¡Correo electrónico copiado!"
                              : "hgalvis@variant.com.co"}
                          </button>
                        </div>
                      </div>

                      <button
                        onClick={() => setShowModal(false)}
                        className="close-button"
                      >
                        Cerrar ventana
                      </button>
                    </div>
                  </div>
                )}
                <div id="open-mobile-menu" className="home-thq-burger-menu-elm">
                  <img
                    alt="pastedImage"
                    src="/pastedimage-yxbd.svg"
                    className="home-thq-mobile-menu-button-elm"
                  />
                </div>
              </div>
            </nav>
          </div>
          <div>
            <div className="home-container12">
              <Script
                html={`<script defer>
/*
Mobile menu - Code Embed
*/

// Mobile menu
const mobileMenu = document.querySelector("#mobile-menu")

// Buttons
const closeButton = document.querySelector("#close-mobile-menu")
const openButton = document.querySelector("#open-mobile-menu")

// On openButton click, set the mobileMenu position left to -100vw
openButton.addEventListener("click", function() {
    mobileMenu.style.transform = "translateX(0%)"
})

// On closeButton click, set the mobileMenu position to 0vw
closeButton.addEventListener("click", function() {
    mobileMenu.style.transform = "translateX(100%)"
})
</script>`}
              ></Script>
            </div>
          </div>
        </header>
        <header className="home-thq-content-elm1">
          <h1 className="home-text108">
            Aplicaciones y desarrollos inteligentes
          </h1>
          <p className="home-text109">
            Agentes de Inteligencia Artificial que automatizan procesos manuales
            para empresas y personas.
          </p>
          <a href="#Title" className="home-link1">
            <div className="home-thq-get-started-elm2">
              <span className="home-text110">Comenzar</span>
            </div>
          </a>
        </header>
        <div className="home-thq-dashboard-preview-elm">
          <div className="home-thq-outline-elm">
            <img
              alt="pastedImage"
              src="/imagen-1000h.png"
              loading="lazy"
              className="home-thq-image-elm"
            />
          </div>
        </div>
      </section>
      <section className="home-thq-features-elm">
        <Title
          text={
            <Fragment>
              <span className="home-text111">
                Permitenos facilitarte las cosas
              </span>
            </Fragment>
          }
          text1={
            <Fragment>
              <span className="home-text112">
                Nuestros agentes automatizan casi cualquier proceso y se
                integran con el 99% de las herramientas del mercado.
              </span>
            </Fragment>
          }
          titleId="Title"
        ></Title>
        <div className="home-thq-cards-elm1">
          <div className="home-container13">
            <div className="card">
              <img
                alt="pastedImage"
                src="/logo-ventas-200h.png"
                className="home-thq-icon-elm1"
              />
              <span className="home-text113">Ventas</span>
              <span className="home-text114">
                Agentes entrenados que charlan con clientes para que tu equipo
                de ventas pueda dedicarse a lo que realmente importa.
              </span>
            </div>
            <div className="home-thq-publish-elm card">
              <img
                alt="pastedImage"
                src="/logo-soporte-200h.png"
                className="home-thq-icon-elm2"
              />
              <span className="home-text115">Soporte</span>
              <span className="home-text116">
                Agentes entrenados por medio de RAG que responden a consultas en
                base a tus manuales y/o documentación.
              </span>
            </div>
          </div>
          <div className="home-container14">
            <div className="card home-thq-analyze-elm">
              <img
                alt="pastedImage"
                src="/logo-secretario-200h.png"
                className="home-thq-icon-elm3"
              />
              <span className="home-text117">Gestión de tareas</span>
              <span className="home-text118">
                Crea tareas, reuniones, envia correos y gestiona contactos con
                un simple mensaje a nuestros agentes.
              </span>
            </div>
            <div className="card">
              <img
                alt="pastedImage"
                src="/logo-automatiza-200h.png"
                className="home-thq-icon-elm4"
              />
              <span className="home-text119">Automatiza lo que desees</span>
              <span className="home-text120">
                Cuentanos que quieres automatizar y tendrás a un equipo de
                ingenieros capacitados para brindarte el mejor servicio.
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="home-thq-quote-container-elm">
        <div className="home-thq-quote-elm1">
          <span className="home-thq-message-elm">
            “Creamos agentes que no solo entienden tu negocio, sino que lo
            representan. Adaptamos su tono, estilo y conocimientos para reflejar
            la voz única de tu marca.”
          </span>
          <div className="home-thq-author-elm">
            <span className="home-thq-quote-elm2">
              <span className="home-text121">—  Hermann Galvis</span>
              <span>, cofundador, Variant AI.</span>
            </span>
          </div>
        </div>
        <br />
        <div className="home-thq-quote-elm1">
          <span className="home-thq-message-elm">
            “Siempre que puedas imaginarlo, puedes automatizarlo, que tan dificil sea ese es otro asunto, atrevete a hacer tus ideas realidad, preguntanos por tu idea de automatización.”
          </span>
          <div className="home-thq-author-elm">
            <span className="home-thq-quote-elm2">
              <span className="home-text121">—  Efrain Galvis</span>
              <span>, cofundador, Variant AI.</span>
            </span>
          </div>
        </div>
      </section>
      <section className="home-thq-statistics-elm">
        <div className="home-container15">
          <ActiveUsers
            caption="— De experiencia en Automatización"
            statistic="8 años"
          ></ActiveUsers>
          <ActiveUsers
            caption="— Herramientas para integrar"
            statistic="1000+"
          ></ActiveUsers>
          <ActiveUsers
            caption="— Para implementar tu solución"
            statistic="30 días"
          ></ActiveUsers>
        </div>
      </section>
      <section className="home-thq-banners-elm">
        <div className="home-thq-banner-manage-elm">
          <div className="home-container16">
            <div className="home-thq-left-elm2">
              <span className="sub-title">Centraliza tus conversaciones</span>
              <span className="home-text124 title">
                Maneja todas tus bandejas en un solo lugar
              </span>
              <span className="home-text125">
                Te ofrecemos centralización de tus bandejas, WhatsApp, Telegram,
                Messenger, instagram, correo, etc. En un solo lugar, donde
                también las puedes integrar con nuestros agentes de IA para que
                respondan por ti cuando desees.
              </span>
              <div className="home-thq-get-started-elm3 template-button">
                <span className="home-text126">Más información</span>
              </div>
            </div>
            <div className="home-thq-image-container-elm1">
              <img
                alt="pastedImage"
                src="/chatwoot-1200w.png"
                className="home-thq-cards-image-elm"
              />
            </div>
          </div>
        </div>
        <div className="home-thq-banner-advanced-analytics-elm" id="how-works">
          <div className="home-container17">
            <div className="home-thq-left-elm3">
              <h2 className="home-text124 title">¿Cómo funciona?</h2>
              <span className="how-work">
                <ul className="how-work-ul">
                  <li className="how-work-li">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M8 9h8" />
                      <path d="M8 13h6" />
                      <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12" />
                    </svg>
                    <h1 className="how-work-li-title">Recepción Instantánea</h1>
                    <p className="how-work-li-text">
                      Al momento que nos escribes, nuestra plataforma activa un
                      receptor que captura tu consulta al instante.
                    </p>
                  </li>
                  <li className="how-work-li">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M6 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -4" />
                      <path d="M12 2v2" />
                      <path d="M9 12v9" />
                      <path d="M15 12v9" />
                      <path d="M5 16l4 -2" />
                      <path d="M15 14l4 2" />
                      <path d="M9 18h6" />
                      <path d="M10 8v.01" />
                      <path d="M14 8v.01" />
                    </svg>
                    <h1 className="how-work-li-title">
                      Comprensión Profunda (IA)
                    </h1>
                    <p className="how-work-li-text">
                      La inteligencia artifical analiza tu intención para darte
                      la solución que buscas.
                    </p>
                  </li>
                  <li className="how-work-li">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="icon"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" />
                    </svg>
                    <h1 className="how-work-li-title">
                      Preparación de la Solución
                    </h1>
                    <p className="how-work-li-text">
                      Nuestro sistema organiza la información de manera lógica
                      para que la explicación sea clara, directa y muy fácil de
                      digerir para ti.
                    </p>
                  </li>
                  <li className="how-work-li">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 5.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667l0 -8.666" />
                      <path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" />
                      <path d="M11 7h5" />
                      <path d="M11 10h6" />
                      <path d="M11 13h3" />
                    </svg>
                    <h1 className="how-work-li-title">
                      Respuesta Humana y Secuencial
                    </h1>
                    <p className="how-work-li-text">
                      Te enviamos la información de forma pausada y natural,
                      simulando el ritmo de una conversación real.
                    </p>
                  </li>
                </ul>
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="home-thq-how-it-works-elm">
        <div className="home-thq-centered-container-elm1">
          <div className="card">
            <div className="home-thq-right-elm2">
              <h2 className="home-text124 title">
                Beneficios de usar variant.
              </h2>
              <div className="home-thq-category-elm1">
                <span className="benefits-title">
                  <img
                    alt="pastedImage"
                    src="/star.png"
                    className="star-icon"
                  />
                  Disponibilidad y Consulta Instantánea 24/7.
                </span>
                <span className="benefits-title">
                  <img
                    alt="pastedImage"
                    src="/star.png"
                    className="star-icon"
                  />
                  Reducción de Errores Humanos ante tareas predecibles y repetitivas.
                </span>
                <span className="benefits-title">
                  <img
                    alt="pastedImage"
                    src="/star.png"
                    className="star-icon"
                  />
                  Análisis de Datos y Reportes Express.
                </span>
                <span className="benefits-title">
                  <img
                    alt="pastedImage"
                    src="/star.png"
                    className="star-icon"
                  />
                  Escalabilidad y Costo-Beneficio.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="home-thq-pricing-elm">
        <div className="home-thq-centered-container-elm4" id="suscriptions">
          <div className="home-thq-heading-elm3">
            <span className="home-text151 title">
               Suscripciones
            </span>
            <span className="home-text152">
              Nuestro modelo de negocio es 100% SaaS, nosotros creamos la infraestructura necesaria para mantener tu chatbot activo 24/7, puedes acceder al chatbot base para consultas simples o al chatbot Premium que administra datos adicionales de clientes.
            </span>
          </div>
          <div className="home-thq-cards-elm2">
            <div className="home-thq-card-elm1">
              <span className="home-text155">ChatBot básico</span>
              <span className="home-text156">
                Quieres dar información a tus clientes?, este chat es sólo informativo ante preguntas frecuentes
              </span>
              <div className="home-thq-get-started-elm6 template-button">
                <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://wa.me/573209683760?text=Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20la%20suscripci%C3%B3n%20a%20su%20chatbot%20b%C3%A1sico"
                      >
                  <span className="home-text157">
                    Solicitalo acá
                  </span>
                </a>
              </div>
              <span className="home-text158">Que incluye</span>
              <div className="home-thq-bullet-points-elm1">
                <div className="home-thq-point-elm10">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon12"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text159">
                    Adecuación de tu chatbot en base a un documento o anexo que nos proporciones.
                  </span>
                </div>
                <div className="home-thq-point-elm11">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon14"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text160">
                    Soporte mensual.
                  </span>
                </div>
              </div>
            </div>
            <div className="home-thq-card-elm2">
              <span className="home-text161">ChatBot Premium</span>
              <span className="home-text162">
                <span>Incluye la funcionalidad del chat básico y adicional puedes solicitar integraciones personalizadas, correos, calendarios, que tus clientes puedan hacer pedidos, registrar sus datos en bases de datos.</span>
                <br></br>
                <span>Se premium</span>
              </span>
              <div className="home-thq-get-started-elm7 template-button">
                <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://wa.me/573209683760?text=Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20la%20suscripci%C3%B3n%20a%20su%20chatbot%20Premium"
                      >
                  <span className="home-text157">
                    Solicitalo acá
                  </span>
                </a>
              </div>
              <span className="home-text169">Que incluye</span>
              <div className="home-thq-bullet-points-elm2">
                <div className="home-thq-point-elm12">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon16"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text170">
                    Chatbot base de respuesta natural ante preguntas frecuentes.
                  </span>
                </div>
                <div className="home-thq-point-elm13">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon18"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text171">
                    Costo de implementación por característica adicional (correo electrónico, Whatapp, actualizaciones de catalogos, bases de datos, etc).
                  </span>
                </div>
                <div className="home-thq-point-elm14">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon20"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text172">
                    Pago a suscripción mensual del servicio basado en caraterísticas adicionales y soporte.
                  </span>
                </div>
                <div className="home-thq-point-elm15">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon22"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text173">
                    Tienes una idea adicional de automatización, consultanos y te cotizamos.
                  </span>
                </div>
              </div>
            </div>
            <div className="home-thq-card-elm3">
              <span className="home-text174">Enterprise</span>
              <span className="home-text175">
                <span>
                  Tu cantidad de clientes está a otro nivel?, si atiendes miles de clientes al día esta es la mejor opción, generamos infraestructura escalable en base a tus necesidades y te cobramos por peticiones.
                </span>
                <br></br>
              </span>
              <div className="home-thq-get-started-elm8 template-button">
                <span className="home-text178">
                                  <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://wa.me/573209683760?text=Me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20la%20suscripci%C3%B3n%20a%20su%20chatbot%20Enterprise"
                      >
                  <span className="home-text157">
                    Solicita Premium
                  </span>
                </a>
                </span>
              </div>
              <span className="home-text182">
                Beneficios plan Premium
              </span>
              <span className="home-text181">
                
              </span>
              <div className="home-thq-bullet-points-elm3">
                <div className="home-thq-point-elm17">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon26"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text183">
                    Infraestructura escalable.
                  </span>
                </div>
                <div className="home-thq-point-elm18">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon28"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text184">
                    Puedes establecer tu límite de conversaciones con clientes
                  </span>
                </div>
                <div className="home-thq-point-elm19">
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon30"
                  >
                    <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                  </svg>
                  <span className="home-text185">
                    Hacemos un seguimiento de la actividad de tu chatbot para ajustar y reducir costos en el tiempo.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="home-thq-testimonals-elm" id="nosotros">
        <span className="home-text187 title">Nosotros</span>
        <div className="home-thq-right-elm3">
          <button
            onClick={last}
            disabled={iTestimonial === 0}
            className="testimonials-buttons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 12l14 0" />
              <path d="M5 12l6 6" />
              <path d="M5 12l6 -6" />
            </svg>
          </button>
          {testimonals
            .slice(iTestimonial, iTestimonial + visibleTestimonials)
            .map((t) => (
              <Testimonal
                key={t.id}
                quote={t.quote}
                avatarSrc={t.avatarSrc}
                name={t.name}
                from={t.from}
              />
            ))}
          <button
            onClick={next}
            disabled={iTestimonial + visibleTestimonials >= testimonals.length}
            className="testimonials-buttons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 12l14 0" />
              <path d="M13 18l6 -6" />
              <path d="M13 6l6 6" />
            </svg>
          </button>
        </div>
      </section>

      <section className="home-thq-faq-elm">
        <div className="home-thq-heading-elm5">
          <span className="home-text199 title">Preguntas frecuentes</span>
          <span className="home-text200">
            Acá puedes encontrar las preguntas que suelen hacer nuestros clientes
          </span>
        </div>
        <div className="home-thq-accordion-elm">
          <div data-faq="closed" className="accordionContainer">
            <div className="home-thq-header-elm2">
              <span className="home-text201">
                — Que necesito para tener mi chatbot?
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <svg viewBox="0 0 1024 1024" className="accordionIcon">
                <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
              </svg>
            </div>
            <div className="accordionContent">
              <span className="home-text202">
                En general sólo un número de whatsapp al que podamos tener acceso, de preferencia una cuenta empresarial certificada ya que genera mucha más confianza, también podemos requerir una cuenta de correo electrónico que permita enviar y recibir correos.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </div>
          <div className="accordionContainer">
            <div className="home-thq-header-elm3">
              <span className="home-text203">
                — Puede mi chatbot divagar y contestar cualquier cosa
              </span>
              <svg viewBox="0 0 1024 1024" className="accordionIcon">
                <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
              </svg>
            </div>
            <div className="accordionContent">
              <span className="home-text204">
                No, el chatbot puede contestar preguntas dentro de su alcance y está limitado a dar respuestas específicas ante contextos específicos ya que no vale la pena permitirle conversaciones no relacionadas con tu negocio.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </div>
          <div data-faq="closed" className="accordionContainer">
            <div className="home-thq-header-elm4">
              <span className="home-text205">
                — Cómo se protegen los datos de mis clientes?
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <svg viewBox="0 0 1024 1024" className="accordionIcon">
                <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
              </svg>
            </div>
            <div className="accordionContent">
              <span className="home-text206">
                Al tomar el servicio de chatbot con nosotros aceptas nuestra política de datos y nosotros nos comprometemos a mantenerlos seguros mediante diversas prácticas de seguridad, los datos pertenecen a quien toma el servicio pero están bajo nuestra supervisión.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </div>
          <div data-faq="closed" className="accordionContainer">
            <div className="home-thq-header-elm5">
              <span className="home-text207">
                — Quien puede acceder a las conversaciones del bot?
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <svg viewBox="0 0 1024 1024" className="accordionIcon">
                <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
              </svg>
            </div>
            <div className="accordionContent">
              <span className="home-text208">
                Al ser el dueño del número de telefono empleado por el chatbot, puedes ver las conversaciones desde tu propio celular.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </div>
          <div data-faq="closed" className="accordionContainer">
            <div className="home-thq-header-elm6">
              <span className="home-text209">
                — Que tanto puedo personalizar mi chatbot?
              </span>
              <svg viewBox="0 0 1024 1024" className="accordionIcon">
                <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
              </svg>
            </div>
            <div className="accordionContent">
              <span className="home-text210">
                El límite está en la tecnología y en los costos por supuesto pero si se puede programar se puede lograr, preguntanos a través de nuestros canales de contacto.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="home-container22">
            <Script
              html={`<script>
// Accordion - Code Embed

const accordionContainers = document.querySelectorAll(".accordionContainer"); // All accordion containers
const accordionContents = document.querySelectorAll(".accordionContent"); // All accordion content
const accordionIcons = document.querySelectorAll(".accordionIcon"); // All accordion icons

accordionContents.forEach((accordionContent) => {
    accordionContent.style.display = "none"; //Hides all accordion contents
});

accordionContainers.forEach((accordionContainer, index) => {
    accordionContainer.addEventListener("click", () => {
        accordionContents.forEach((accordionContent) => {
            accordionContent.style.display = "none"; //Hides all accordion contents
        });

        accordionIcons.forEach((accordionIcon) => {
            accordionIcon.style.transform = "rotate(0deg)"; // Resets all icon transforms to 0deg (default)
        });

        if (accordionContainer.classList.contains("accordion-open")) { // Checks if this container has class "accordion-open"
            accordionContainer.classList.remove("accordion-open"); // Removes class "accordion-open"
        } else {
            accordionContainers.forEach((accordionContainer) => {
                accordionContainer.classList.remove("accordion-open"); // Removes class "accordion-open" from all containers
            });

            accordionContainer.classList.add("accordion-open"); // Adds class "accordion-open" to this container
            accordionContents[index].style.display = "flex"; // Shows accordion content
            accordionIcons[index].style.transform = "rotate(180deg)"; // Rotates accordion icon 180deg
        }
    });
});

/*
Here's what the above is doing:
    1. Selects all accordion containers, contents, and icons
    2. Hides all accordion contents
    3. Adds an event listener to each accordion container
    4. When an accordion container is clicked, it:
        - Hides all accordion contents
        - Resets all icon transforms to 0deg (default)
        - Checks if this container has class "accordion-open"
            - If it does, it removes class "accordion-open"
            - If it doesn't, it:
                - Removes class "accordion-open" from all containers
                - Adds class "accordion-open" to this container
                - Shows accordion content
                - Rotates accordion icon 180deg
*/
</script>`}
            ></Script>
          </div>
        </div>
      </section>
      <footer className="home-thq-footer-elm">
        <div className="home-thq-top-elm">
          <div className="home-thq-left-elm5">
            <span className="home-text211">Subscribete a nuestras noticias</span>
            <div className="home-thq-subscription-elm">
              <input
                type="email"
                placeholder="Enter your email"
                className="home-textinput input"
              />
              <div className="home-thq-subscribe-elm">
                <span className="home-text212">Subscribirse</span>
              </div>
            </div>
            <span className="home-text213">
             Al suscribirte aceptas nuestros terminos y condicones.
            </span>
            <div className="home-thq-contact-elm">
              <span className="home-text214">Contact</span>
              <a
                href="mailto:use@active-app.com?subject=Support"
                className="home-link2"
              >
                service@variant.com.co
              </a>
            </div>
          </div>
          <div className="home-thq-right-elm4">
            <div className="home-thq-category-elm6">
              <span className="home-text215">Soluciones adicionales</span>
              <div className="home-thq-links-elm3">
                <span className="home-text216">Automatizaciones de infraestructura</span>
                <span className="home-text217">Automatizaciones de flujos</span>
                <span className="home-text218">Diseño de código</span>
                <span className="home-text218">DevOps</span>
                <span className="home-text218">Cloud</span>
              </div>
            </div>
            <div className="home-thq-category-elm7">
              <span className="home-text221">Companía</span>
              <div className="home-thq-links-elm4">
                <span className="home-text222">Sobre nosotros</span>
                <span className="home-text223">Team</span>
                <span className="home-text224">News</span>
                <span className="home-text225">Partners</span>
                <span className="home-text226">Careers</span>
                <span className="home-text227">Press &amp; Media</span>
                <a
                  href="/politica-de-privacidad"
                  className="home-text227"
                  style={{ textDecoration: "none" }}
                >
                  Política de Privacidad
                </a>
              </div>
            </div>
            <div className="home-thq-category-elm8">
              <span className="home-text228">Solutions</span>
              <div className="home-thq-links-elm5">
                <span className="home-text229">Twitter</span>
                <span className="home-text230">Linkedin</span>
                <span className="home-text231">Crunchbase</span>
                <span className="home-text232">Instagram</span>
                <span className="home-text233">Facebook</span>
              </div>
            </div>
          </div>
        </div>
        <div className="home-thq-bottom-elm">
          <img
            alt="pastedImage"
            src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
            className="home-thq-branding-elm"
          />
          <span className="home-text234">Copyright © Active - 2022</span>
        </div>
      </footer>
      <div>
        <div className="home-container24">
          <Script
            html={`<script>
              (function(){
  (function(d,t) {
    var BASE_URL="http://chatwoot.variant.com.co";
    var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
    g.src=BASE_URL+"/packs/js/sdk.js";
    g.async = true;
    s.parentNode.insertBefore(g,s);
    g.onload=function(){
      window.chatwootSDK.run({
        websiteToken: 'Kt3eqNk5sY93WpXv4mCXvnDM',
        baseUrl: BASE_URL
      })
    }
  })(document,"script");
})()
              </script>`}
          ></Script>
        </div>
      </div>
      <div>
        <div className="home-container26">
          <Script
            html={`<script>
              (function(){
  (function(d,t) {
    var BASE_URL="http://chatwoot.variant.com.co";
    var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
    g.src=BASE_URL+"/packs/js/sdk.js";
    g.async = true;
    s.parentNode.insertBefore(g,s);
    g.onload=function(){
      window.chatwootSDK.run({
        websiteToken: 'Kt3eqNk5sY93WpXv4mCXvnDM',
        baseUrl: BASE_URL
      })
    }
  })(document,"script");
})()
              </script>`}
          ></Script>
        </div>
      </div>

    </div>
  )
}

export default Home
